import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, CreateProps, EditProps } from 'react-admin'

import * as actions from 'customReducers/lessonReducer/actions'

import { Drawer } from 'components'

import { CreateWeek } from 'modules/weeks'
import { CreateVideo } from 'modules/video'
import { CreateTag } from 'modules/tags'
import { CreatePerson } from 'modules/persons'
import { CreateAttachment } from 'modules/attachments'
import { CreateCommentQuestion } from 'modules/comments-question'
import { CreateImage } from 'modules/images'

interface LessonModuleStateProps {
  lessonModule: {
    formData: object
    openAttachments: boolean
    openCommentQuestion: boolean
    openPerson: boolean
    openTag: boolean
    openVideo: boolean
    openWeeks: boolean
    openImage: boolean
  }
}

interface ResponseItemProps {
  id: number
  slug?: string
  path?: string
  title?: string
  type?: string
  vimeo_id?: string
}

type Props = CreateProps & EditProps

export const Drawers = (props: Props) => {
  const dispatch = useDispatch()
  const lessonModuleState = useSelector(
    (state: LessonModuleStateProps) => state.lessonModule,
  )

  const onSubmitFailure = (data?: ResponseItemProps) => {
    console.log('FAILURE ON LESSON ')
    // notify('post_failed', 'warning')
  }

  return (
    <>
      <Drawer open={lessonModuleState.openWeeks} anchor="right">
        <CreateWeek
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.weeksDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              onClick={() => dispatch(actions.weeksDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openVideo} anchor="right">
        <CreateVideo
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.videosDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.videosDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openTag} anchor="right">
        <CreateTag
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.tagsDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.tagsDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openPerson} anchor="right">
        <CreatePerson
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.personsDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.personsDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openImage} anchor="right">
        <CreateImage
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.imagesDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.imagesDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openAttachments} anchor="right">
        <CreateAttachment
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.attachmentsDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.attachmentsDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openVideo} anchor="right">
        <CreateVideo
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.videosDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.videosDialog())}
            />
          }
        />
      </Drawer>

      <Drawer open={lessonModuleState.openCommentQuestion} anchor="right">
        <CreateCommentQuestion
          {...props}
          shouldRedirect={false}
          showAside={false}
          onSubmitSuccess={(data: ResponseItemProps) =>
            dispatch(actions.commentsTitileDialog())
          }
          onSubmitFailure={(data: ResponseItemProps) => onSubmitFailure(data)}
          closeDrawer={
            <Button
              label="Cancelar"
              redirect={false}
              submitOnEnter={false}
              variant="text"
              color="primary"
              onClick={() => dispatch(actions.commentsTitileDialog())}
            />
          }
        />
      </Drawer>
    </>
  )
}
